var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0abc11e13035a3abcfa85a608a374ca88a171b76"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kitchen-bath@classy-companies"]={id:"0abc11e13035a3abcfa85a608a374ca88a171b76"};
      